// Runtime-injected application config.
//
// The portal image is environment-agnostic: Auth0 + Datadog config is read at
// CONTAINER START from env vars (the Docker entrypoint regenerates /config.js,
// which sets `window.__APP_CONFIG__`) rather than baked at build time. This lets
// one portal image promote across environments (dev → qa → prod) like the API
// image already does (WOL-376 #6).
//
// Fallback: when a runtime field is absent/empty we use the build-time `VITE_*`
// value. So an environment that injects nothing at runtime is unchanged — e.g.
// dev (whose CI still bakes the `VITE_*` build-args) and local `vite dev` (which
// reads `.env`) both keep working exactly as before.

const runtime: Window['__APP_CONFIG__'] =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

// Prefer a non-empty runtime value; otherwise fall back to the baked build value.
const pick = (
  runtimeValue: string | undefined,
  buildValue: string | undefined,
): string | undefined =>
  runtimeValue && runtimeValue.length > 0 ? runtimeValue : buildValue;

export const appConfig = {
  auth0Domain: pick(runtime.auth0Domain, import.meta.env.VITE_AUTH0_DOMAIN),
  auth0ClientId: pick(runtime.auth0ClientId, import.meta.env.VITE_AUTH0_CLIENT_ID),
  auth0Audience: pick(runtime.auth0Audience, import.meta.env.VITE_AUTH0_AUDIENCE),
  ddRumApplicationId: pick(
    runtime.ddRumApplicationId,
    import.meta.env.VITE_DD_RUM_APPLICATION_ID,
  ),
  ddRumClientToken: pick(
    runtime.ddRumClientToken,
    import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
  ),
  ddSite: pick(runtime.ddSite, import.meta.env.VITE_DD_SITE),
  ddService: pick(runtime.ddService, import.meta.env.VITE_DD_SERVICE),
  ddEnv: pick(runtime.ddEnv, import.meta.env.VITE_DD_ENV),
  ddVersion: pick(runtime.ddVersion, import.meta.env.VITE_DD_VERSION),
};
